

export const REPORT_CUSTOMER_REPORT_REQUEST = "REPORT_CUSTOMER_REPORT_REQUEST";
export const REPORT_CUSTOMER_REPORT_SUCCESS = "REPORT_CUSTOMER_REPORT_SUCCESS";
export const REPORT_CUSTOMER_REPORT_FAILURE = "REPORT_CUSTOMER_REPORT_FAILURE";

export const REPORT_CUSTOMER_REPORT_SEARCH_REQUEST = "REPORT_CUSTOMER_REPORT_SEARCH_REQUEST";
export const REPORT_CUSTOMER_REPORT_SEARCH_SUCCESS = "REPORT_CUSTOMER_REPORT_SEARCH_SUCCESS";
export const REPORT_CUSTOMER_REPORT_SEARCH_FAILURE = "REPORT_CUSTOMER_REPORT_SEARCH_FAILURE";